import { render, staticRenderFns } from "./indexType.vue?vue&type=template&id=6c20c898&"
import script from "./indexType.vue?vue&type=script&lang=js&"
export * from "./indexType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports